import { atom } from "jotai";

import _ from "lodash";

interface IPublishState {
  lastpublish: string | null;
  lastchange: string | null;
}

const defaultPublishState: IPublishState = {
  lastpublish: null,
  lastchange: null,
};

const examplePublishAtom = atom<IPublishState>(defaultPublishState);

const changesSchema = JSON.stringify({
  lastchange: "string",
  lastpublish: "string",
});

const momentPublishAtom = atom<IPublishState>({
  lastpublish: null,
  lastchange: null,
});
const landmarkPublishAtom = atom<IPublishState>({
  lastpublish: null,
  lastchange: null,
});
const settingsPublishAtom = atom<IPublishState>({
  lastpublish: null,
  lastchange: null,
});

export {
  examplePublishAtom,
  changesSchema,
  momentPublishAtom,
  landmarkPublishAtom,
  settingsPublishAtom,
  defaultPublishState,
};
export type { IPublishState };
